<template>
  <div class="card-item">
    <div class="box">
      <slot name="item_title" :qty="qty" :title="title" :status="status">{{
        title
      }}</slot>
    </div>
    <div class="box qty">
      <slot name="item_qty" :qty="qty" :title="title" :status="status">{{
        qty
      }}</slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "ActivityFlowCardItem",
  props: {
    title: {
      type: String
    },
    qty: {
      type: [Number, String]
    },
    status: {
      type: String,
      default: ""
    }
  }
};
</script>

<style lang="scss" scoped>
.card-item {
  height: 30px;
  width: 100%;
  padding: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-self: flex-start;
  margin: 10px 0 10px 0;
  border-bottom: 0.5px solid #90939936;

  .box {
    top: 10.5px;
  }
}
</style>
